export default __webpack_public_path__ + "static/media/discordIcon.cf3efe0e.svg";